"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
var ko = require("knockout");
var $ = require("jquery");
var _ = require("lodash");
require("bootstrap");
(function (ModalType) {
    ModalType[ModalType["Custom"] = 0] = "Custom";
    ModalType[ModalType["ConfirmDelete"] = 1] = "ConfirmDelete";
    ModalType[ModalType["Confirm"] = 2] = "Confirm";
    ModalType[ModalType["Alert"] = 3] = "Alert";
    ModalType[ModalType["Success"] = 4] = "Success";
    ModalType[ModalType["Error"] = 5] = "Error";
    ModalType[ModalType["ConfirmDeleteWithoutUndone"] = 6] = "ConfirmDeleteWithoutUndone";
    ModalType[ModalType["ReverseConfirm"] = 7] = "ReverseConfirm";
})(exports.ModalType || (exports.ModalType = {}));
var ModalType = exports.ModalType;
var defaultOptions = {
    width: "600px",
    type: ModalType.ConfirmDelete,
    okBtnText: "OK",
    deleteBtnText: "Удалить"
};
var ModalDialogComponent = (function (_super) {
    __extends(ModalDialogComponent, _super);
    function ModalDialogComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.title = ko.observable();
        this.message = ko.observable();
        this.minWidth = ko.observable();
        this.maxWidth = ko.observable();
        this.type = ko.observable();
        this.deleteBtnText = ko.observable();
        this.okBtnText = ko.observable();
        this.templateId = ko.observable();
        this.isVisible = ko.observable(false);
        this.templateData = ko.observable();
        this.deleteWithoutUndoneText = ko.observable();
        this.deleteWithoutUndoneBtnDisabled = ko.pureComputed(function () {
            var text = _this.deleteWithoutUndoneText() || "";
            return text.toUpperCase() !== "УДАЛИТЬ";
        });
        var $el = $(element);
        if ($el.parent()[0] !== document.body) {
            $el.appendTo(document.body);
        }
        this.$modal = $el.find(".modal");
        var modalOptions = _.defaults({}, params.modal, {
            backdrop: true,
            show: false
        });
        this.$modal.modal(modalOptions);
    }
    ModalDialogComponent.prototype.show = function (modalOptions) {
        var _this = this;
        var options = _.defaults(modalOptions, defaultOptions);
        this.title(options.title);
        this.minWidth(options.minWidth);
        if (options.maxWidth) {
            var width = parseInt(options.maxWidth.substring(0, options.maxWidth.indexOf("px")));
            var maxWidth = $(window).width() - 40;
            if (width > maxWidth) {
                options.maxWidth = maxWidth + "px";
            }
        }
        this.maxWidth(options.maxWidth);
        this.deleteBtnText(options.deleteBtnText);
        this.okBtnText(options.okBtnText);
        this.type(options.type);
        if (this.type() === ModalType.Custom) {
            if (_.isEmpty(options.templateId)) {
                throw new Error("\"CustomMarkup\" property should be specified.");
            }
            if (!(document.getElementById(options.templateId))) {
                throw new Error("Template " + options.templateId + " not found");
            }
            if (options.viewModel === undefined) {
                options.viewModel = window["app"].viewModel;
            }
            this.templateData(options.viewModel);
            this.templateId(options.templateId);
        }
        else {
            if (_.isEmpty(options.message)) {
                throw new Error("\"Message\" property should be specified.");
            }
            this.message(options.message);
            this.onSubmit = options.onSubmit;
        }
        this.errorMessages([]);
        this.$modal.modal("show");
        this.isVisible(true);
        this.$modal.on("hide.bs.modal", function () {
            _this.isVisible(false);
            if (options.onHide) {
                options.onHide(_this.getModal());
            }
        });
        if (options.onShow) {
            setTimeout(function () {
                options.onShow(_this.getModal());
            });
        }
    };
    ModalDialogComponent.prototype.toggleProcessing = function (isProcessing) {
        this.processing(isProcessing);
    };
    ModalDialogComponent.prototype.showErrorMessage = function (messages) {
        this.errorMessages(messages);
    };
    ModalDialogComponent.prototype.submitBtnClick = function () {
        var _this = this;
        this.toggleProcessing(true);
        try {
            var result = this.onSubmit();
            if (result && result["done"]) {
                result.done(function (result) {
                    if (result) {
                        if (result.isSuccessful) {
                            _this.hide();
                        }
                        else {
                            _this.errorMessages(result.messages);
                        }
                    }
                }).always(function () {
                    _this.processing(false);
                });
            }
            else {
                this.processing(false);
            }
        }
        catch (ex) {
            this.errorMessages(["Упс, произошла ошибка. Сообщите, пожалуйста, в тех. поддержку."]);
            console.error(ex.toString());
            this.processing(false);
        }
    };
    ModalDialogComponent.prototype.hide = function () {
        this.$modal.modal("hide");
    };
    ModalDialogComponent.prototype.getModal = function () {
        return this.$modal;
    };
    return ModalDialogComponent;
}(baseComponent_1.default));
exports.ModalDialogComponent = ModalDialogComponent;
var componentName = "modal-dialog";
if (!ko.components.isRegistered(componentName)) {
    ko.components.register(componentName, {});
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ModalDialogComponent;
//# sourceMappingURL=modalDialog.js.map